import { useState } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { Combobox, IconButton } from "@similarweb/ui-components";

type PlaybooksNewButtonProps = {
    canCreateShared: boolean;
    dataAutomation?: string;
    onNewPlaybook: (isSharedWithAccount: boolean) => void;
};

export const PlaybooksNewButton = ({
    canCreateShared,
    dataAutomation = "playbooks-new-button",
    onNewPlaybook,
}: PlaybooksNewButtonProps) => {
    const { translate } = useTranslate();
    const [isOpen, setIsOpen] = useState(false);

    const newPlaybookLabel = translate("si.playbooks.button.new");

    if (!canCreateShared) {
        return (
            <IconButton
                dataAutomation={dataAutomation}
                iconSize="xs"
                iconName="add"
                onClick={() => onNewPlaybook(false)}
            >
                {newPlaybookLabel}
            </IconButton>
        );
    }

    const handleSelect = (isSharedWithAccount: boolean) => {
        setIsOpen(false);
        onNewPlaybook(isSharedWithAccount);
    };

    return (
        <Combobox
            placement="bottom-end"
            isOpen={isOpen}
            onOpenChange={setIsOpen}
            width="fit-content"
            data-automation={`${dataAutomation}-combobox`}
        >
            <Combobox.Trigger>
                <IconButton
                    dataAutomation={`${dataAutomation}-trigger`}
                    iconSize="xs"
                    iconName="add"
                >
                    {newPlaybookLabel}
                </IconButton>
            </Combobox.Trigger>
            <Combobox.Content
                selectionMode="single"
                ariaLabel={newPlaybookLabel}
            >
                <Combobox.Option
                    id="private"
                    textValue={translate("si.playbooks.button.new.private")}
                    onClick={() => handleSelect(false)}
                    data-automation={`${dataAutomation}-private`}
                >
                    <Combobox.OptionLabel>{translate("si.playbooks.button.new.private")}</Combobox.OptionLabel>
                </Combobox.Option>
                <Combobox.Option
                    id="shared"
                    textValue={translate("si.playbooks.button.new.shared")}
                    onClick={() => handleSelect(true)}
                    data-automation={`${dataAutomation}-shared`}
                >
                    <Combobox.OptionLabel>{translate("si.playbooks.button.new.shared")}</Combobox.OptionLabel>
                </Combobox.Option>
            </Combobox.Content>
        </Combobox>
    );
};
